import React, { useEffect } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import SelectedRouteSegmentGeometryV2 from "./SelectedRouteSegmentGeometryV2";
import { getSessionUnsnappedData, receiveUnsnappedData } from "redux/actions";

const unsnappedRouteGeometrySelector = (state) => state.playlist.data.unsnappedData;
const sessionIDSelector = (state) => state.playlist.data.routeID;

const UnsnappedRouteGeometry = () => {
    const dispatch = useDispatch();

    const unsnappedRouteGeom = useSelector(unsnappedRouteGeometrySelector);
    const selectedSessionID = useSelector(sessionIDSelector);

    useEffect(() => {
        const unsnappedDataSessionID = _.get(unsnappedRouteGeom, ["sessionID"]);
        if (selectedSessionID && unsnappedDataSessionID !== selectedSessionID) {
            dispatch(receiveUnsnappedData(selectedSessionID, null));
            dispatch(getSessionUnsnappedData(selectedSessionID));
        }
    }, [dispatch, selectedSessionID, unsnappedRouteGeom]);

    return (
        <SelectedRouteSegmentGeometryV2
            routeGeomOverrideData={unsnappedRouteGeom}
            lineColour={"#a34040"}
        />
    );
};

export default UnsnappedRouteGeometry;
